export default {
  ALWAYS_DENY: 'always_deny',
  ALWAYS_ALLOW: 'always_grant',
};
